import SportsGymnasticsOutlinedIcon from '@mui/icons-material/SportsGymnasticsOutlined';

/**
 * Somatótipo: componente dominante da constituição física (ectomorfo,
 * mesomorfo ou endomorfo). Referência: tipologia de Sheldon (1940) e método
 * antropométrico de Heath-Carter (1967). Aqui se registra só o componente
 * dominante, sem o cálculo numérico de Heath-Carter. Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/somatotype.php.
 */
// Um conjunto único de figuras para qualquer sexo, como o formato corporal.
const imageFor = (position) => `somatotipo-${position}.png`;

const somatotype = {
  key: 'somatotype',
  name: 'Somatótipo',
  description: 'Constituição física: ecto, meso ou endomorfo',
  details: 'Classifica a constituição física pelo componente que predomina: ectomorfo (linear e magro), mesomorfo (musculoso) ou endomorfo (arredondado, com mais gordura). Segue a tipologia de Sheldon e o método de Heath-Carter, mas registra só o componente dominante, sem o cálculo numérico das três notas. Ajuda a orientar o plano alimentar e o treino e a acompanhar a mudança de composição ao longo do tratamento. Um clique marca o tipo do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: SportsGymnasticsOutlinedIcon,
  accent: 'green',
  options: [
    { value: 'ectomorph', label: 'Ectomorfo', caption: 'Linear', image: imageFor(1), help: 'Corpo longo e estreito, pouca gordura e pouca massa muscular. Ganha peso com dificuldade.' },
    { value: 'mesomorph', label: 'Mesomorfo', caption: 'Musculoso', image: imageFor(2), help: 'Ombros largos, músculos aparentes e ossatura forte. Responde rápido ao treino.' },
    { value: 'endomorph', label: 'Endomorfo', caption: 'Arredondado', image: imageFor(3), help: 'Contorno arredondado, com mais gordura, sobretudo no abdome. Ganha peso com facilidade.' },
  ],
};

export default somatotype;
